import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import clsx from 'clsx'
import { TonalButton } from 'components/empty-page-state'
import InfoAlert from 'components/info-alert'
import { PageHeader } from 'components/page-header'
import UpgradeSuccessModal from 'components/upgrade-success-modal'
import OpenInNewOutlinedIcon from 'components/material-symbol/icons/OpenInNew'
import { useUpgradeFlow } from 'lib/hooks/use-upgrade-flow'
import { useVirtualCoachingEnabled } from 'lib/pga-coach/use-virtual-coaching'
import useBookingTypesStyles from 'pages/pga-coach/bookings/booking-types/styles'
import RequestsTable from './requests-table'
import { useStyles } from './styles'
import { REQUEST_TABS } from './utils'

export const VIRTUAL_COACHING_UPGRADE_PAGE_NAME = 'virtual-coaching'

// Renders the requests surfaces for Coach+ coaches and, for everyone else, the
// same upgrade banner the offerings page shows. The requests list also shows
// its static empty state under the banner, as an upgraded coach with no
// requests would see it. The gate owns the upgrade flow so the success modal
// still shows after the Stripe redirect, when the coach is already on Coach+
// and the children render instead of the banner.
const VirtualCoachingCoachPlusGate = ({ children, showEmptyRequests }) => {
  const classes = useStyles()
  const bookingTypesClasses = useBookingTypesStyles()
  const enabled = useVirtualCoachingEnabled()
  const {
    upgradeLoading,
    handleUpgradeClick,
    showSuccessModal,
    handleDismiss,
  } = useUpgradeFlow(VIRTUAL_COACHING_UPGRADE_PAGE_NAME)

  return (
    <>
      {enabled ? (
        children
      ) : (
        <>
          <PageHeader title="Virtual Coaching" />
          <Box className={classes.upgradeContent}>
            <InfoAlert
              variant="promo"
              className={bookingTypesClasses.upgradePromoCallout}
              title="Virtual Coaching is a PGA Coach+ feature"
              action={
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleUpgradeClick}
                  disabled={upgradeLoading}
                  startIcon={<OpenInNewOutlinedIcon />}
                >
                  Upgrade Now
                </Button>
              }
            >
              <Typography variant="body2">
                Upgrade to PGA Coach+ to sell swing analysis, review golfer
                videos, and reply with an Onform link or an uploaded video.
              </Typography>
            </InfoAlert>
            {showEmptyRequests ? (
              <Box
                className={clsx(classes.tableShell, classes.upgradeTableShell)}
              >
                <RequestsTable
                  requests={[]}
                  tab={REQUEST_TABS.READY}
                  emptyTitle="Waiting for you to upgrade"
                  emptyCaption="Once you're on PGA Coach+, golfer swing videos will show up here for you to review and reply to."
                  emptyAction={
                    <TonalButton
                      onClick={handleUpgradeClick}
                      disabled={upgradeLoading}
                      startIcon={<OpenInNewOutlinedIcon />}
                    >
                      Upgrade Now
                    </TonalButton>
                  }
                />
              </Box>
            ) : null}
          </Box>
        </>
      )}
      <UpgradeSuccessModal isOpen={showSuccessModal} onClose={handleDismiss} />
    </>
  )
}

VirtualCoachingCoachPlusGate.propTypes = {
  children: PropTypes.node,
  showEmptyRequests: PropTypes.bool,
}

export default VirtualCoachingCoachPlusGate
